import ReactDOM from "react-dom/client";
import App from "./App";
import { Suspense } from "react";
import { Box } from "@mui/material";
import { LoadingView } from "./presentation/component/LoadingView";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Suspense fallback={<LoadingView minHeight="100vh"/>}>
    <App />
  </Suspense>
);
